import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';

import { SUGGEST_MINIMUM_CHARACTERS_FOR_HIGHLIGHT_TO_WORK } from '../../constants';
import { sanitizeMini } from '../../utils/sanitizeMini';

export const TextHighlighter: React.FC<{
  children: string;
  highlightValue: string | undefined;
}> = props => {
  if (!props.highlightValue || props.highlightValue.length < SUGGEST_MINIMUM_CHARACTERS_FOR_HIGHLIGHT_TO_WORK) {
    return <UIText1 display="inline">{props.children}</UIText1>;
  }

  const sections = props.children
    .split(new RegExp(`(${sanitizeMini(props.highlightValue)})`, 'gi'))
    .filter(maybeEmptyString => maybeEmptyString);

  return (
    <>
      {sections.map((section, index) => (
        <UIText1
          display="inline"
          fontWeight={section.toLowerCase() === props.highlightValue?.toLowerCase() ? '700' : '400'}
          key={index}
        >
          {section}
        </UIText1>
      ))}
    </>
  );
};
